<template>
  <div class="view box grow">
    <vue-scroll class="full-height">
      <div class="network-req">
        <h3>Networking Requirements</h3>
        <p
          class="subtitle2"
        >The agent must be able to contact the IQHub system and the following addresses and ports must be accessible:</p>
        <span
          class="body2 display-block"
        >{{`${networkInfo.environment}-controlplane-0.${networkInfo.customer_name}.confluera.com:2379`}}</span>
        <span
          class="body2 display-block"
        >{{`${networkInfo.environment}-controlplane-1.${networkInfo.customer_name}.confluera.com:2379`}}</span>
        <span
          class="body2 display-block"
        >{{`${networkInfo.environment}-controlplane-2.${networkInfo.customer_name}.confluera.com:2379`}}</span>
        <span
          class="body2 display-block"
        >{{`${networkInfo.environment}-controlplane-0.${networkInfo.customer_name}.confluera.com:8181`}}</span>
        <span
          class="body2 display-block"
        >{{`${networkInfo.environment}-kafka-0.${networkInfo.customer_name}.confluera.com:9092`}}</span>
        <span
          class="body2 display-block"
        >{{`${networkInfo.environment}-kafka-1.${networkInfo.customer_name}.confluera.com:9092`}}</span>
        <span
          class="body2 display-block"
        >{{`${networkInfo.environment}-kafka-2.${networkInfo.customer_name}.confluera.com:9092`}}</span>
      </div>
    </vue-scroll>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import {
  NETWORK_INFO_REQ,
  NETWORK_INFO_SUCCESS
} from "@/store/modules/network_info/network-info.type";

export default {
  name: "InstallationNetworkReq",
  data() {
    return {
      breadcrumbs: [{ title: "Home" }, { title: "Installation" }]
    };
  },
  methods: {},
  created() {
    Promise.all([this.$store.dispatch(NETWORK_INFO_REQ)]);
  },
  mounted() {},
  computed: {
    ...mapGetters(["networkInfo"])
  }
};
</script>

<style scoped>
@import "assets/styles/_variables.css";
@import "assets/styles/text.css";

.network-req {
  > span {
    border-bottom: 1px solid var(--border-color);
    padding: 8px 0px;

    &:last-of-type {
      margin-bottom: 24px;
    }
  }
}

pre {
  white-space: pre-line;
}

.fab {
  font-size: 1.5em;
  vertical-align: middle;
}

.icon-logo {
  display: inline-block;
  height: 21px;
  width: 18px;
  background: #495057;
  mask-size: contain;
  mask-repeat: no-repeat;
  vertical-align: middle;
}

.error {
  text-align: center;
  color: var(--text-color-danger);
}

>>> .el-tabs {
  height: calc(100% - 100px);
}

>>> .el-tabs__content {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/installation/InstallationNetworkReq.vue